<template>
  <section class="overflow-auto p-5 w-full" style="height: calc(100% - 4.3rem)">
    <div class="md:max-w-[43rem]">
      <div class="flex items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">이메일</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input
              class=""
              v-model="optionEmail"
              @input="onValidateEmail"
              type="text"
              placeholder="이메일을 입력해주세요."
            />
          </div>
          <div v-if="errMsgEmail.length" class="cs-feedback cs-feedback-error">
            <i class="fi fi-sr-comment-exclamation"></i><span>{{ errMsgEmail }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="flex items-center mt-5">
        <span class="flex mt-4 w-60 text-desc">기본 후처리 비용(원)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input class="" v-model="optionDefaultPostProcessCost" @keyup="optionDefaultPostProcessCost = numberComma(optionDefaultPostProcessCost)" type="text" placeholder="0" />
          </div>
        </div>
      </div> -->
      <!-- <div class="flex items-center mt-5">
        <span class="flex mt-4 w-60 text-desc">후처리 계산 비용(원)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input class="" v-model="optionPostProcessCost" @keyup="optionPostProcessCost = numberComma(optionPostProcessCost)" type="text" placeholder="0" />
          </div>
        </div>
      </div>
      <div class="flex items-center mt-5">
        <span class="flex mt-4 w-60 text-desc">기본 도색 비용(원)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input class="" v-model="optionDefaultPaintCost" @keyup="optionDefaultPaintCost = numberComma(optionDefaultPaintCost)" type="text" placeholder="0" />
          </div>
        </div>
      </div>
      <div class="flex items-center mt-5">
        <span class="flex mt-4 w-60 text-desc">도색 계산 비용(원)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input class="" v-model="optionPaintCost" @keyup="optionPaintCost = numberComma(optionPaintCost)" type="text" placeholder="0" />
          </div>
        </div>
      </div> -->

      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">배송 비용(원)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input
              class=""
              v-model="optionShippingCost"
              @keyup="optionShippingCost = numberComma(optionShippingCost)"
              @blur="onInputShipping"
              type="text"
              placeholder="0"
            />
          </div>
        </div>
      </div>
      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">도색 주의 표시글</span>
        <div class="w-full">
          <div class="p-3 w-full h-44 cs-form">
            <textarea class="w-full h-full leading-5" v-model="optionCautionPaint"></textarea>
          </div>
        </div>
      </div>

      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">모델 생산 가능 크기<br />(X, Y, Z mm)</span>
        <div class="flex w-full">
          <div class="flex mr-2 cs-form" data-height="xs">
            <input
              class=""
              v-model="optionBuildSizeX"
              type="text"
              placeholder="0"
              @input="onInputNumber"
              @blur="onInputBlurNumber"
            />
          </div>
          <span class="m-auto">x</span>
          <div class="mr-2 ml-2 cs-form" data-height="xs">
            <input
              class=""
              v-model="optionBuildSizeY"
              type="text"
              placeholder="0"
              @input="onInputNumber"
              @blur="onInputBlurNumber"
            />
          </div>
          <span class="m-auto">x</span>
          <div class="ml-2 cs-form" data-height="xs">
            <input
              class=""
              v-model="optionBuildSizeZ"
              type="text"
              placeholder="0"
              @input="onInputNumber"
              @blur="onInputBlurNumber"
            />
          </div>
        </div>
      </div>

      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">모델 부피 비율</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input
              class=""
              v-model="optionVolumeMultiply"
              @input="onInputRatio"
              @blur="onInputBlurRatio"
              type="text"
              placeholder="0"
            />
          </div>
        </div>
      </div>

      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">모델 최소 부피</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input
              class=""
              v-model="optionMinVolume"
              @input="onInputNumber"
              @blur="onInputBlurNumber"
              type="text"
              placeholder="0"
            />
          </div>
        </div>
      </div>

      <div class="flex mt-5 items-top max-w-[35rem]">
        <span class="flex min-w-[11rem] text-desc">모델 한 방향의<br />최대 길이 (mm)</span>
        <div class="w-full">
          <div class="flex w-full cs-form" data-height="md">
            <input
              class=""
              v-model="optionModelMaxSize"
              @input="onInputNumber"
              @blur="onInputBlurNumber"
              type="text"
              placeholder="0"
            />
          </div>
        </div>
      </div>

      <div class="flex mt-5 items-top">
        <span class="flex min-w-[11rem] text-desc">빈팩킹 설정</span>
        <div class="flex w-full items-top">
          <div class="flex items-center">
            <div class="m-auto mr-2 whitespace-nowrap">간격(mm)</div>
            <div class="flex mr-2 cs-form w-[5rem]" data-height="xs">
              <input
                class=""
                v-model="optionPackingGap"
                type="text"
                placeholder="0"
                @input="onInputNumber"
                @blur="onInputBlurNumber"
              />
            </div>
          </div>
          <span class="m-auto mx-3 h-[1.5rem] border-l border-stone-200"> </span>
          <div class="flex items-center">
            <div class="m-auto mr-2 whitespace-nowrap">탐색 범위(%)</div>
            <div class="mr-2 ml-2 cs-form w-[5rem]" data-height="xs">
              <input
                class=""
                v-model="optionPackingSearchMarginPercent"
                type="text"
                placeholder="0"
                @input="onInputNumber"
                @blur="onInputBlurNumber"
              />
            </div>
          </div>
          <span class="m-auto mx-3 h-[1.5rem] border-l border-stone-200"> </span>
          <div class="flex items-center">
            <div class="m-auto mr-2 whitespace-nowrap">셀 크기(mm)</div>
            <div class="ml-2 cs-form w-[5rem]" data-height="xs">
              <input
                class=""
                v-model="optionPackingCellSize"
                type="text"
                placeholder="0"
                @input="onInputNumber"
                @blur="onInputBlurNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10 text-right">
      <loader-button
        ref="submit"
        class="w-56 cs-pd-btn-lg"
        :cssButton="'cs-btn-base'"
        @click="onSubmit"
      >
        <template v-slot:title><span>저장</span></template>
      </loader-button>
    </div>
  </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>

<script setup>
import {ref, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {OptionsStore} from "../../store/options-store";
import {numberToComma, removeComma, validateEmail} from "../../js/utils";
import LoaderButton from "../../components/LoaderButton.vue";

const optionsStore = OptionsStore();
const {
  optionEmail,
  optionShippingCost,
  optionCautionPaint,
  optionBuildSizeX,
  optionBuildSizeY,
  optionBuildSizeZ,
  optionVolumeMultiply,
  optionMinVolume,
  optionModelMaxSize,
  optionPackingGap,
  optionPackingCellSize,
  optionPackingSearchMarginPercent,
} = storeToRefs(optionsStore);

let errMsgEmail = ref("");

onMounted(() => {
  optionsStore.reqGetOptions();
});

const onSubmit = () => {
  optionsStore.reqSubmit();
};

const onValidateEmail = (e) => {
  errMsgEmail.value = validateEmail(e.target.value);
};

const onInputShipping = () => {
  if (0 === optionShippingCost.value.length) {
    optionShippingCost.value = "0";
  }
};

const numberComma = (src) => {
  if (src.length) {
    src = src.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    if (src.length) {
      return numberToComma(Number.parseInt(removeComma(src)));
    }
  }
  return "";
};

const onInputNumber = () => {
  optionBuildSizeX.value = removeComma(optionBuildSizeX.value);
  optionBuildSizeY.value = removeComma(optionBuildSizeY.value);
  optionBuildSizeZ.value = removeComma(optionBuildSizeZ.value);
  optionMinVolume.value = removeComma(optionMinVolume.value);
  optionModelMaxSize.value = removeComma(optionModelMaxSize.value);
  optionPackingGap.value = removeComma(optionPackingGap.value);
  optionPackingCellSize.value = removeComma(optionPackingCellSize.value);
  optionPackingSearchMarginPercent.value = removeComma(optionPackingSearchMarginPercent.value);

  const regExp = /^\d{0,10}$/;
  if (!regExp.test(optionBuildSizeX.value)) {
    optionBuildSizeX.value = optionBuildSizeX.value.substring(0, optionBuildSizeX.value.length - 1);
  }
  if (!regExp.test(optionBuildSizeY.value)) {
    optionBuildSizeY.value = optionBuildSizeY.value.substring(0, optionBuildSizeY.value.length - 1);
  }
  if (!regExp.test(optionBuildSizeZ.value)) {
    optionBuildSizeZ.value = optionBuildSizeZ.value.substring(0, optionBuildSizeZ.value.length - 1);
  }
  if (!regExp.test(optionMinVolume.value)) {
    optionMinVolume.value = optionMinVolume.value.substring(0, optionMinVolume.value.length - 1);
  }
  if (!regExp.test(optionModelMaxSize.value)) {
    optionModelMaxSize.value = optionModelMaxSize.value.substring(
      0,
      optionModelMaxSize.value.length - 1
    );
  }

  optionBuildSizeX.value = numberComma(optionBuildSizeX.value.replace(/(^0+)/, ""));
  optionBuildSizeY.value = numberComma(optionBuildSizeY.value.replace(/(^0+)/, ""));
  optionBuildSizeZ.value = numberComma(optionBuildSizeZ.value.replace(/(^0+)/, ""));
  optionMinVolume.value = numberComma(optionMinVolume.value.replace(/(^0+)/, ""));
  optionModelMaxSize.value = numberComma(optionModelMaxSize.value.replace(/(^0+)/, ""));
  optionPackingGap.value = numberComma(optionPackingGap.value.replace(/(^0+)/, ""));
  optionPackingCellSize.value = numberComma(optionPackingCellSize.value.replace(/(^0+)/, ""));
  optionPackingSearchMarginPercent.value = numberComma(
    optionPackingSearchMarginPercent.value.replace(/(^0+)/, "")
  );
};
const onInputBlurNumber = () => {
  if (0 === optionBuildSizeX.value.length) {
    optionBuildSizeX.value = "0";
  }
  if (0 === optionBuildSizeY.value.length) {
    optionBuildSizeY.value = "0";
  }
  if (0 === optionBuildSizeZ.value.length) {
    optionBuildSizeZ.value = "0";
  }
  if (0 === optionModelMaxSize.value.length) {
    optionModelMaxSize.value = "0";
  }
  if (0 === optionPackingGap.value.length) {
    optionPackingGap.value = "0";
  }
  if (0 === optionPackingCellSize.value.length) {
    optionPackingCellSize.value = "0";
  }
  if (0 === optionPackingSearchMarginPercent.value.length) {
    optionPackingSearchMarginPercent.value = "0";
  }
};

const onInputRatio = () => {
  optionVolumeMultiply.value = optionVolumeMultiply.value.replace(/[^0-9.]/g, "");
};
const onInputBlurRatio = () => {
  if (typeof optionVolumeMultiply.value === "number") {
    return;
  }
  if (0 < optionVolumeMultiply.value.length) {
    if ("." === optionVolumeMultiply.value[0]) {
      optionVolumeMultiply.value = "0" + optionVolumeMultiply.value;
    }
  }
};
</script>
